export enum ProductRequestStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  REOPENED = 'REOPENED',
}

export enum UnitOfMeasure {
  EACH = 'EACH',
  BOX = 'BOX',
  CASE = 'CASE',
}

export interface ProductRequest {
  id: number
  catalogNumber: string
  deviceDescription: string
  unitOfMeasure: UnitOfMeasure
  deviceId: string
  serialNumber: string
  expirationDate: string
  deviceCount: number
  companyId: number
  status: ProductRequestStatus
  attachmentsDirectories?: string[]
}
